import React from 'react';
import {Redirect, Route, Switch} from 'react-router-dom';
import asyncComponent from '../../../util/asyncComponent';

const Manual = ({match}) => (
  <div className="app-wrapper">
    <Switch>
       <Route path={`${match.url}/manual`} component={asyncComponent(() => import('./routes/manual'))}/>
       <Route component={asyncComponent(() => import('app/routes/extraPages/routes/404'))}/>
    </Switch>
  </div>
);

export default Manual;